module.exports = __webpack_public_path__ + "img/smart-graphic.3c215032.jpg";